define('services/common/ajax/huaweiTrade',['app'], function (app) {
    app.factory('HuaweiTrade', ['auiAjaxWithError', function (auiAjaxWithError) {

        return {
            sign: auiAjaxWithError.curryOld('huawei.trade.service.sign'),
            get: auiAjaxWithError.curryOld('huawei.trade.service.get'),
            set: auiAjaxWithError.curryOld('huawei.trade.service.set'),
            queryTrade: auiAjaxWithError.curryOld('huawei.trade.service.queryTrade'),
            qryUserInfo: auiAjaxWithError.curryOld('huawei.trade.service.qryUserInfo'),
            modUserInfo: auiAjaxWithError.curryOld('huawei.trade.service.modUserInfo'),
            getDevelopSign: auiAjaxWithError.curryOld('huawei.trade.service.getDevelopSign'),
            notifytrigger: auiAjaxWithError.curryOld('huawei.trade.service.notifytrigger'),
            reportGateway:auiAjaxWithError.curryOld('huawei.trade.admin.report')
        }
    }])
});
